import React, { useState, useEffect } from 'react'
import { Autocomplete, Box, Button, Divider, TextField } from '@mui/material'
import { RootState } from '../../../reducers'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from '../Pathologist/inboxStyles'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined'
import CircularProgress from '@mui/material/CircularProgress'
import {
  getLabTransferList,
  transferAssign,
  getITAdminAssignedData,
  getITAdminQCCasesData,
  getITAdminUnassignedData,
  getUnassignedData,
  getQCCasesData,
  getAssignedData,
  getDispatchData,
  getInProgressData,
  getReadyForPickupData,
  getSearchByTRFData,
} from '../../../actions'

export default function AssignCaseModal({
  userId,
  trfId,
  isSearch,
  open,
  onClose,
  userDetails,
  setFirstPage,
  filterName,
  filterValue,
  sortField,
  startDate,
  endDate,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)
  const getUsers = useSelector((state: RootState) => state.addLabTransferList)
  const { re_transfer_success, re_transfer_error } = useSelector((state: RootState) => state.transferResponse)
  const { re_transferList_success, re_transferList_error } = useSelector(
    (state: RootState) => state.getLabTransferListResponse,
  )
  let userNames = []
  const { role, user } = useSelector((state: RootState) => state.userLogin)
  const displayUsersList = getUsers?.data
  const [newUserId, setUserId] = useState(null)
  const [disableSubmit, setDisableSubmit] = useState(true)
  const [loading, setLoading] = useState(false)
  const [isTranferListLoading, setTranferListLoading] = useState(true)
  const getClassNames = () => (disableSubmit ? `${classes.disableBtn} ` : `${classes.btn} ${classes.buttonMargin}`)

  if (re_transferList_success && displayUsersList) {
    userNames = displayUsersList.map((user) => {
      return `${user.first_name} ${user.last_name}`
    })
  }

  useEffect(() => {
    if (open) {
      dispatch(
        getLabTransferList({
          caseUserId: userDetails?.user_id ? userDetails?.user_id : 0,
          id: userId,
          casedId: userDetails?.case_id,
        }),
      )
    }
  }, [open])

  useEffect(() => {
    setTimeout(() => setTranferListLoading(false), 4000)
  }, [isTranferListLoading])

  const onUserIdChange = (val) => {
    if (val === null) setUserId(null)
    else {
      const lastName = val.split(' ')
      const lastNameValue = lastName.length > 2 ? lastName[0] + ' ' + lastName[1] : lastName[0]
      const filterUserResults = displayUsersList.filter((value) => {
        return value.first_name == lastNameValue
      })
      const newUser = filterUserResults[0].id
      setUserId(newUser)
    }
  }
  useEffect(() => {
    if (newUserId) {
      setDisableSubmit(false)
    } else {
      setDisableSubmit(true)
    }
  }, [newUserId])

  const handleAssignCase = async (event, caseid: any) => {
    setLoading(true)
    setOpenErrorSnackBar(false)
    setOpenSuccessSnackBar(false)
    if (newUserId && userDetails.stage_id !== 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS') {
      await dispatch(
        transferAssign({
          id: userId,
          newUserId: newUserId,
          casedId: userDetails?.case_id,
          currentUserId: '0',
        }),
      )
      setFirstPage(true)
      setTimeout(updateDataTable, 1500)
    } else {
      onClose(true)
      setOpenErrorSnackBar(true)
    }
  }

  const updateDataTable = async () => {
    if (isSearch) {
      await dispatch(
        getSearchByTRFData({
          user_id: user,
          trf_id: trfId,
          user_role: role,
        }),
      )
    } else {
      if (role === 'NL_WOMA_ADMIN') {
        if (userDetails?.slide_status_id === 1) {
          await dispatch(
            getReadyForPickupData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'ready_for_pickup',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        } else if (userDetails?.slide_status_id === 2) {
          await dispatch(
            getDispatchData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'dispatch',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        } else {
          if (userDetails?.stage_id === 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL') {
            await dispatch(
              getITAdminUnassignedData({
                id: `${userId}`,
                filterField: filterName !== '' ? filterName : 'created_datetime',
                filterValue: filterValue,
                caseView: 'unassigned',
                startDate: startDate,
                endDate: endDate,
                sortOrder: 'asc',
                sortField: sortField,
              }),
            )
          } else if (userDetails?.stage_id === 'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL') {
            await dispatch(
              getITAdminAssignedData({
                id: `${userId}`,
                filterField: filterName !== '' ? filterName : 'created_datetime',
                filterValue: filterValue,
                caseView: 'assigned',
                startDate: startDate,
                endDate: endDate,
                sortOrder: 'asc',
                sortField: sortField,
              }),
            )
          } else if (userDetails?.stage_id === 'PRIMARY_DIAGNOSIS_ASSIGNED_READY') {
            await dispatch(
              getITAdminAssignedData({
                id: `${userId}`,
                filterField: filterName !== '' ? filterName : 'created_datetime',
                filterValue: filterValue,
                caseView: 'assigned',
                startDate: startDate,
                endDate: endDate,
                sortOrder: 'asc',
                sortField: sortField,
              }),
            )
          }
        }
      } else if (role === 'NL_LabManager') {
        if (userDetails?.stage_id === 'PRIMARY_DIAGNOSIS_NO_SLOTS_INITIAL') {
          await dispatch(
            getUnassignedData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'unassigned',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        } else if (userDetails?.stage_id === 'PRIMARY_DIAGNOSIS_ASSIGNED_INITIAL') {
          await dispatch(
            getAssignedData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'assigned',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        } else if (userDetails?.stage_id === 'PRIMARY_DIAGNOSIS_ASSIGNED_READY') {
          await dispatch(
            getQCCasesData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'qc_cases',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        }
      } else if (role === 'NL_SpecimenLogistics') {
        if (userDetails?.slide_status_id === 1) {
          await dispatch(
            getReadyForPickupData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'ready_for_pickup',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        } else if (userDetails?.slide_status_id === 2) {
          await dispatch(
            getDispatchData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'dispatch',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        } else if (userDetails?.slide_status_id === 3 || userDetails?.slide_status_id === 4) {
          await dispatch(
            getInProgressData({
              id: `${userId}`,
              filterField: filterName !== '' ? filterName : 'created_datetime',
              filterValue: filterValue,
              caseView: 'in_progress',
              startDate: startDate,
              endDate: endDate,
              sortOrder: 'asc',
              sortField: sortField,
            }),
          )
        }
      }
    }
    onClose(false)
    setOpenSuccessSnackBar(true)
    setUserId(null)
    setLoading(false)
  }

  function handleCloseDialog() {
    setUserId(null)
    setTranferListLoading(true)
  }

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      {openSuccessSnackBar && re_transfer_success && <SuccessSnackBar message="Successfully transfered the case" />}
      {openErrorSnackBar && re_transfer_error && <ErrorSnackBar message="The selected case is already transferred" />}
      <Dialog fullWidth maxWidth="sm" id="hello" open={open} onClose={onClose} style={{ height: '750px' }}>
        <DialogTitle className={classes.dialogTitle}>Assign</DialogTitle>
        <Divider />
        {isTranferListLoading === true && (
          <DialogContent style={{ height: '215px' }}>
            <CircularProgress style={{ marginTop: '50px', marginLeft: '250px' }} />
          </DialogContent>
        )}
        {isTranferListLoading === false && re_transferList_error && (
          <DialogContent style={{ minHeight: '165px' }}>
            <WarningAmberOutlinedIcon color="warning" />
            <div className={classes.warningIcon}>
              Unable to Assign or Transfer case, no pathologists matches the criteria. Pathologists availability depends
              on State, Procedure code, calendar availability. Please check your criteria and try again.
            </div>
          </DialogContent>
        )}
        {re_transferList_success && isTranferListLoading === false && (
          <>
            <DialogContent classes={{ root: classes.dialogContentBox }} style={{ minHeight: '165px' }}>
              <DialogContentText className={classes.dialogContent}>
                {` Please select the pathologist if you wish to change the assignment.`}
              </DialogContentText>
              <Autocomplete
                id="combo-box-demo"
                options={userNames}
                onChange={(e, val) => onUserIdChange(val)}
                sx={{ width: 300, marginTop: '15px' }}
                renderInput={(params) => <TextField {...params} label={`Assign To`} />}
              />
              {loading && (
                <CircularProgress className={classes.loadingIndicator} style={{ width: '30px', height: '30px' }} />
              )}
            </DialogContent>
          </>
        )}

        {re_transferList_success && isTranferListLoading === false && (
          <DialogActions className={classes.buttonActions}>
            <Button
              className={getClassNames()}
              onClick={(event) => handleAssignCase(event, userDetails?.case_id)}
              endIcon={<CheckIcon />}
            >
              Submit
            </Button>
            <Button
              onClick={function (event) {
                handleCloseDialog()
                onClose()
              }}
              variant="outlined"
              className={classes.buttonMargin}
              endIcon={<ClearIcon />}
            >
              Cancel
            </Button>
          </DialogActions>
        )}
        {re_transferList_error && isTranferListLoading === false && (
          <DialogActions className={classes.buttonActions}>
            <Button
              onClick={function (event) {
                handleCloseDialog()
                onClose()
              }}
              variant="outlined"
              className={classes.buttonMargin}
              endIcon={<ClearIcon />}
            >
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  )
}
